<script>
  import { navigate } from "svelte-navigator";
  import { _ } from 'svelte-i18n'

  import Link from '/Atoms/Link'
  import IconClose from '/components/Icons/IconCloseBlur'
  import Video from '/components/Atoms/Video'
  import AudioButton from '/components/Atoms/AudioButton'
  import Body from '/Groups/Body'
  import AlmanacGallery from '/Groups/AlmanacGallery'
  import Related from '/Groups/Related'
  
  import Sketchfab from '/Atoms/Sketchfab'
  import BitnikBadge from '/Atoms/BitnikBadge'

  export let data, vampire = false, bitnik = false, liliana = false

  const terms = {
    "nA": $_("terms.nA"),
    "allRightsReserved": $_("terms.allRightsReserved"),
    "publicDomainWork": $_("terms.publicDomainWork"),
    "attributionSharealike": $_("terms.attributionSharealike"),
    "attributionNoncommercial": $_("terms.attributionNoncommercial"),
    "attributionNoderivates": $_("terms.attributionNoderivates"),
    "attributionNoncommercialSharealike": $_("terms.attributionNoncommercialSharealike"),
    "attributionNoncommercialNoderivates": $_("terms.attributionNoncommercialNoderivates"),
  }

  const item = data?.gallery || {}

  const title = item?.title
  const subtitle = item?.subtitle
  const people = item?.relatedPeople?.[0]?.members?.map( member => member.title).join(", ")
  const translator = item?.translator

  const license = item?.license
  const credits = item?.credits

  const type = item?.textMediaCategory

  const vimeoUrl = item?.videoSource?.[0]?.vimeoUrl

  const audioUrl = item?.audioSource?.[0]?.audioFile
  const audioTitle = item?.title

  const collection = item?.collection

  let body = item?.body || []

  let lilianaVideoBlock = null

  if (liliana) {
    let videoBlockIndex = body.findIndex(b => b.typeHandle === "videoBlock")
    if (videoBlockIndex > -1) {
      lilianaVideoBlock = body.splice(videoBlockIndex, 1)[0]
    }
  }

</script>

<section class="almanac-item" >

  <div class="close">
    <div class="close-icon">
      <Link to="/almanac">
        <IconClose />
      </Link>
    </div>
  </div>

  <div class="content">
    {#if type }
      <h2 class="category">
        { type }
      </h2>
    {/if}
    {#if title || subtitle || translator}
      <div class="header">
        <h1 class="title">{title}</h1>
        {#if subtitle}
          <h3 class="subtitle">{subtitle}</h3>
        {/if}
        {#if people}
          <h3 class="people">{people}</h3>
        {/if}
        {#if translator}
          <h3 class="subtitle translator">{translator}</h3>
        {/if}
      </div>
    {/if}
    {#if vampire}
      <div class="media">
        <Sketchfab />
      </div>
    {/if}
    {#if vimeoUrl || audioUrl}
      <div class="media">
        {#if vimeoUrl}
          {#if liliana}
            <div class="liliana">
              <div>
                <Video {vimeoUrl} />
              </div>
              {#if lilianaVideoBlock}
                <div>
                  <Video vimeoUrl={lilianaVideoBlock.vimeoUrl} />
                </div>
              {/if}
            </div>
          {:else}
            <Video {vimeoUrl} />
          {/if}
          {#if license}
            <div class="caption">
              License: {terms[license]}
            </div>
          {/if}
          {#if credits}
            <div class="caption">
              {credits}
            </div>
          {/if}
        {/if}
        {#if audioUrl}
          <AudioButton src={ audioUrl } title={ audioTitle } />
        {/if}
      </div>
    {/if}
    {#if collection}
      <div class="gallery">
        <AlmanacGallery {collection} />
      </div>
    {/if}

    <Body {body} almanac/>

    <div class="related">
      <Related data={item} almanac />
    </div>

  </div>

</section>

{#if bitnik}
  <BitnikBadge />
{/if}

<style lang="scss">
  section {
    height: 100vh;
    background-color: $color-beige;
    overflow-y: scroll;
    position: relative;
    text-align: center;

    //@include grid;
    //@include grid-padding;

    .close {
      @include grid-dist("right");
      /*isolation: isolate;*/
      /*position: sticky;*/
      position: fixed;
      top:0;
      left: calc( 100vw - 85px - #{$grid-gap-large} );
      @include media-small {
        transform-origin: 90% 10%; // not a good asset
        transform: scale(0.8);
      }
      .close-icon {
        cursor: pointer;
      }
    }
    .content {
      //grid-column: 3 / span 8;
      display: inline-block;
      max-width: 820px;
      margin: auto;
      box-sizing: border-box;
      //border: dashed 1px rgba(0,255,255,1);

      margin-left: 40px;
      margin-right: 40px;

      @include media-1col-only {
        margin-left: 20px;
        margin-right: 20px;
      }

      @include media-large-only {
        padding-left: 40px;
        padding-right: 40px;
        // note: images don't have this padding
      }

      margin-top: 88px;
      margin-bottom: 35px + $audioplayer-height;
    }
  }

  .category {
    @include typo-serif-small-caps-28;
    color: $color-red;
    margin-bottom: 32px;
  }

  .header {
    margin-bottom: 30px;
    @include media-large-only {
      max-width: 580px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .media {
    margin-bottom: 30px;
    @include media-large-only {
      margin-left: -40px;
      margin-right: -40px;
    }
  }

  .liliana {
    & > * {
      width: calc(50% - 8px);
      float: left;
      &:not(:first-child) {
        float: right;
      }
    }
    &::after {
      content: "";
      clear: both;
      display: table;
      margin-bottom: 1em;
    }
  }

  .caption {
    text-align: center;
    @include typo-grotesk-title-captions-20;

    padding: 5px 40px 0 40px;
    @include media-small {
      padding: 5px 20px 0 20px;
    }

    & + .caption {
      padding-top: 0;
    }
  }

  .gallery {
    margin-bottom: 25px;
    @include media-large-only {
      //width: calc(100vw - 60px);
      //left: calc( 0.5 * ( -100vw + 780px ) + 10px );
      margin-left: calc( -0.5 * ( 100vw - ( 820px + 40px ) ) - 40px );
      margin-right: calc( -0.5 * ( 100vw - ( 820px + 40px ) ) - 40px );
      position: relative;
    }
    @include media-xl {
      margin-left: calc( -0.5 * ( #{$maxwidth} - 820px ) );
      margin-right: calc( -0.5 * ( #{$maxwidth} - 820px ) );
    }
  }

  .title {
    @include typo-grotesk-title-50;
  }

  .subtitle, .people {
    @include typo-grotesk-title-30;
    &.translator {
      @include typo-grotesk-text-24;
    }
  }

  .title + .people, .subtitle + .people {
    margin-top: 8px;
  }

  .subtitle {
    font-style: italic;
  }

  .content {
    @include typo-serif-text-28;
  }

  .related {
    padding-top: 40px;
    text-align: left;
  }

</style>
